import React from 'react';
import { navigateTo, stopBackgroundScrolling } from 'common/utils/app.utils';
import config from 'config/config';

const SingleUpgradeCancelModal = ({ setshowPopup }) => {
  const hidePopup = () => {
    setshowPopup(false);
    stopBackgroundScrolling(false);
  };

  return (
    <div className="drawerSection">
      <div className="popup-section cancelOrder">
        <h2>Cancel Order</h2>
        <p>Please confirm if you want to cancel this order and be redirected to dashboard.</p>
        <div className="buttonSection">
          <button type="button" className="btn activebtn" onClick={hidePopup}>
            No
          </button>
          <button type="button" className="btn activebtn btn-transparent" onClick={() => navigateTo(config.aehdashboardUrl)}>
            Yes
          </button>
        </div>
      </div>
    </div>
  );
};

export default SingleUpgradeCancelModal;
